// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

export class Controller {
    /** @ngInject */
    constructor(ApprovalFormsService, ConfirmDeleteModal, $state, Alert) {
        this.ApprovalFormsService = ApprovalFormsService;
        this.ConfirmDeleteModal = ConfirmDeleteModal;
        this.$state = $state;
        this.Alert = Alert;
    }

    $onInit() {
        if (this.approvalForm.approvalPolicy) {
            this.selectedPolicyId = this.approvalForm.approvalPolicy.id;
        } else {
            this.selectedPolicyId = '-1';
        }
        this.$approvalForm = angular.copy(this.approvalForm);
    }

    saveDisabled(form) {
        return form.$invalid || (this.approvalForm.name === this.$approvalForm.name && this.approvalForm.description === this.$approvalForm.description && this.approvalForm.approvalPolicy.id === this.selectedPolicyId);
    }

    policyChanged() {
        this.$approvalForm.approvalPolicy = this.policies.find(policy => policy.id === this.selectedPolicyId);
    }

    save() {
        this.isSaving = true;
        this.ApprovalFormsService.updateApprovalForm(this.$approvalForm, this.companyId)
            .then((approvalForm) => {
                this.Alert('success', 'global.messages.operation-successful');
                this.$state.reload('company.request-center');
                this.approvalForm = approvalForm;
                this.$approvalForm = angular.copy(this.approvalForm);
            })
            .finally(() => this.isSaving = false);
    }

    isLoading() {
        return this.isDeleting || this.isSaving;
    }

    remove() {
        this.ConfirmDeleteModal('Are you sure you want to delete this approval form')
            .then(() => {
                this.isRemoving = true;
                this.ApprovalFormsService.deleteApprovalForm(this.approvalForm.id, this.companyId)
                    .then(() => this.$state.go('company.request-center.approval-forms.list', {}, {reload: 'company.request-center'}))
                    .finally(() => this.isRemoving = false);
            })
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/request-center/forms/edit/approval-forms-edit.controller.js